export default __webpack_public_path__ + "static/media/room-3Bed-tripple.0cc83ca5.jpg";